import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const Section = ({ id, title, children }) => (
  <section id={id} className="scroll-mt-24">
    <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-2">{title}</h2>
    <div className="space-y-3 text-sm sm:text-base text-muted-foreground leading-relaxed">
      {children}
    </div>
  </section>
);

const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 overflow-x-hidden">
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-2xl sm:text-3xl font-bold">Terms of Service</CardTitle>
          <CardDescription>
            Last updated: Feb 7, 2026
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-8">
          <div className="text-sm sm:text-base text-muted-foreground leading-relaxed space-y-3">
            <p>
              These Terms of Service ("Terms") govern your use of IronSource Dashboard (the "Service")
              provided by NAndroidEx ("we", "us"). By accessing or using the Service, you agree to these Terms.
            </p>
            <p>
              This page is provided as a general template and will be refined as we finalize the frontend
              privacy/terms implementation and product flows.
            </p>
          </div>

          <div className="rounded-lg border bg-card p-4 sm:p-5">
            <h2 className="text-base sm:text-lg font-semibold text-foreground mb-2">Contents</h2>
            <ul className="grid gap-2 text-sm sm:text-base text-primary">
              <li><a className="hover:underline" href="#eligibility">Eligibility</a></li>
              <li><a className="hover:underline" href="#accounts">Accounts</a></li>
              <li><a className="hover:underline" href="#acceptable-use">Acceptable use</a></li>
              <li><a className="hover:underline" href="#third-party">Third-party services</a></li>
              <li><a className="hover:underline" href="#disclaimers">Disclaimers</a></li>
              <li><a className="hover:underline" href="#limitation">Limitation of liability</a></li>
              <li><a className="hover:underline" href="#changes">Changes</a></li>
            </ul>
          </div>

          <div className="space-y-8">
            <Section id="eligibility" title="Eligibility">
              <p>
                You must have the legal authority to enter into these Terms and comply with all applicable
                laws and regulations when using the Service.
              </p>
            </Section>

            <Section id="accounts" title="Accounts">
              <p>
                You are responsible for maintaining the confidentiality of your account credentials and for
                all activity that occurs under your account. Please notify us if you suspect unauthorized use.
              </p>
            </Section>

            <Section id="acceptable-use" title="Acceptable use">
              <p>You agree not to misuse the Service. For example, you will not:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Access or attempt to access systems or data without authorization</li>
                <li>Interfere with or disrupt the Service (including security testing without permission)</li>
                <li>Upload or transmit malicious code</li>
                <li>Use the Service in violation of applicable laws</li>
              </ul>
            </Section>

            <Section id="third-party" title="Third-party services">
              <p>
                The Service may integrate with third-party services (for example, IronSource APIs). Your use
                of third-party services is governed by their terms and policies.
              </p>
            </Section>

            <Section id="disclaimers" title="Disclaimers">
              <p>
                The Service is provided on an "as is" and "as available" basis. To the maximum extent
                permitted by law, we disclaim all warranties, express or implied.
              </p>
            </Section>

            <Section id="limitation" title="Limitation of liability">
              <p>
                To the maximum extent permitted by law, NAndroidEx will not be liable for indirect, incidental,
                special, consequential, or punitive damages, or any loss of profits or revenues, arising from
                your use of the Service.
              </p>
            </Section>

            <Section id="changes" title="Changes">
              <p>
                We may update these Terms from time to time. Changes will be posted on this page with an
                updated "Last updated" date. Continued use of the Service after changes means you accept the
                updated Terms.
              </p>
            </Section>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Terms;
